import {
  dayjs,
  Radio,
  ShapeIcon,
  Typography,
} from "@flash-tecnologia/hros-web-ui-v2";
import { Box } from "src/components/core-components/atoms/Box/box";
import { useManageMembersForm } from "../../context/manage-members-context";

import * as SC from "./invite-members.styles";

export const InviteMembers = () => {
  const { invitationType, onInvitationTypeChange, onInvitationDateChange } =
    useManageMembersForm();

  return (
    <SC.Container>
      <Box flexDirection="column" gap="s">
        <Box flexDirection="column" gap="xs5">
          <Typography.Headline7 weight={700} color="neutral.20">
            Escolha quando será enviado o convite de acesso à plataforma para a
            sua equipe
          </Typography.Headline7>
          <Typography.Body4 color="neutral.40">
            Selecione uma opção para continuar
          </Typography.Body4>
        </Box>
        <Box flex={1} justifyContent="space-between" gap="xs3">
          <SC.RadioCard checked={invitationType === "INSTANTLY"}>
            <Box $width="100%" justifyContent="space-between">
              <ShapeIcon
                name="IconSend"
                variant="default"
                color="var(--color-secondary-50)"
                size={48}
                style={{ flexShrink: 0 }}
              />
              <Radio
                checked={invitationType === "INSTANTLY"}
                onChange={() => {
                  onInvitationTypeChange("INSTANTLY");
                  onInvitationDateChange(undefined);
                }}
              />
            </Box>
            <div>
              <Typography variant="headline9" color="neutral.20">
                Enviar agora
              </Typography>
              <Typography variant="body4" color="neutral.40">
                Ao concluir, enviaremos o convite aos contatos cadastrados.
              </Typography>
            </div>
          </SC.RadioCard>

          <SC.RadioCard checked={invitationType === "SCHEDULED"}>
            <Box $width="100%" justifyContent="space-between">
              <ShapeIcon
                name="IconCalendarEvent"
                variant="default"
                color="var(--color-secondary-50)"
                size={48}
                style={{ flexShrink: 0 }}
              />
              <Radio
                checked={invitationType === "SCHEDULED"}
                onChange={() => onInvitationTypeChange("SCHEDULED")}
              />
            </Box>
            <div>
              <Typography variant="headline9" color="neutral.20">
                Agendar envio
              </Typography>
              <Typography variant="body4" color="neutral.40">
                Defina a data para envio do convite aos contatos cadastrados.
              </Typography>
            </div>
            {invitationType === "SCHEDULED" && (
              <SC.AnimatedDatePicker
                size="small"
                fromDate={dayjs().add(1, "day").toDate()}
                label="Escolha uma data"
                onDateChange={(value) =>
                  onInvitationDateChange(value?.toISOString())
                }
              />
            )}
          </SC.RadioCard>
        </Box>
      </Box>
    </SC.Container>
  );
};
